import React, { useRef, useState, useEffect, useContext } from "react";
import { Carousel } from "react-responsive-carousel";
import { finalTranslations } from "../../localTranslation";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./LatestNewsCarousel.module.css";
import { normalisedTimeFormat } from "../../helpers/helpers";
import styled from "styled-components/macro";
import SwitcherNews from "./SwitcherNews.svg";
import SwitcherNewsClicked from "./SwitcherNewsClicked.svg";
import { votingApi } from "../../helpers/fetcher";
import { ACTIONS } from "../../store/Actions";
import { DataContext } from "../../store/GlobalState";
import SpotlightBtn from '../SpotlightBtn'
const LatestNews = ({ lang, phenNews, isTranslated, langForTransState }) => {
  const {
    state: { cmtsData, getTheWholeCardHtmlElms },
    dispatch,
  } = useContext(DataContext);
  const phenNewsLimted3 = React.useMemo(() => {
    return !!phenNews?.length ? phenNews?.slice(0, 10) : [];
  }, [phenNews]);
  const cardMediaTextRef = useRef();
  const cardLatestTextRef = useRef();

  const cardMediaTextRef2 = useRef();
  const cardLatestTextRef2 = useRef();

  const [translations, settranslations] = useState(null);
  const [originalTitle, setoriginalTitle] = useState(null);
  const [originalText, setoriginalText] = useState(null);

  useEffect(() => {
    const fetcher = async () => {
      const [res1] = await Promise.all([
        (originalTitle || cardLatestTextRef2.current) &&
          votingApi.translation(
            "en",
            langForTransState,
            originalTitle ?? cardLatestTextRef2.current
          ),
        // votingApi.translation("en", langForTransState, originalText)
      ]);
      const res2 = await Promise.all(
        !!(originalText ?? cardMediaTextRef2.current)?.length &&
          (originalText ?? cardMediaTextRef2.current)?.map((child) => {
            if (!!child) {
              return votingApi.translation(
                "en",
                langForTransState,
                child?.innerHTML
              );
            }
          })
      );

      settranslations(() => {
        return {
          res1,
          res2,
        };
      });
    };
    !!isTranslated && !!originalTitle && !!originalText && fetcher();
  }, [isTranslated, originalText, originalTitle, langForTransState]);

  useEffect(() => {
    if (!!phenNews?.length) {
      if (true) {
        if (
          !!cardLatestTextRef.current?.innerHTML &&
          !cardLatestTextRef2.current
        ) {
          cardLatestTextRef2.current = cardLatestTextRef.current?.innerHTML;
        }
        cardLatestTextRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardLatestTextRef2.current);
        let namesOfPhencollection = [];
        const phenList = Array.from(cardMediaTextRef.current?.children ?? []);
        let tempElm =
          !!phenList?.length &&
          phenList?.length > 1 &&
          phenList[1].querySelectorAll("li.slide");

        tempElm = Array.from(tempElm ?? []);
        !!tempElm?.length &&
          tempElm?.map((child) => {
            if (!!child) {
              const tempElm = child?.querySelector("h4");

              namesOfPhencollection = [...namesOfPhencollection, tempElm];
            }
          });

        namesOfPhencollection = namesOfPhencollection?.filter((name) => !!name);
        if (
          !cardMediaTextRef2.current &&
          !!cardMediaTextRef.current?.children &&
          !!namesOfPhencollection?.length
        ) {
          cardMediaTextRef2.current = namesOfPhencollection;
        }
        !!cardMediaTextRef2.current &&
          !originalText &&
          setoriginalText(() => cardMediaTextRef2.current);

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD6,
        //   payload: true
        // })
      }
    }
  }, [dispatch, isTranslated, originalTitle, originalText, phenNews]);

  return (
    <div className={styles.carouselWrapper} ref={cardMediaTextRef}>
      {!!phenNewsLimted3?.length && (
        <>
          <>
            {!isTranslated && (
              <h3 className={styles.h3Title} ref={cardLatestTextRef}>
                {lang === "fi"
                  ? finalTranslations?.latestNewsTitle?.fi
                  : finalTranslations?.latestNewsTitle?.en}
              </h3>
            )}
          </>
          <>
            {!!isTranslated && (
              <h3
                className={styles.h3Title}
                dangerouslySetInnerHTML={{ __html: translations?.res1?.data }}
              ></h3>
            )}
          </>
        </>
      )}
      <Carousel
        autoPlay
        infiniteLoop
        showArrows={false}
        showThumbs={false}
        className={styles.carouselBackground}
      >
        {!!phenNewsLimted3?.length &&
          phenNewsLimted3?.map((news, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "80%",
                  textAlign: "left",
                }}
              >
                <a
                  className=""
                  style={{ cursor: "pointer", textDecoration: "none" }}
                  href={news?.content?.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {!isTranslated && (
                    <h4
                      className={styles.h4Title}
                      // ref={cardMediaTextRef}
                    >
                      {news?.content?.title?.substring(0, 150) ||
                        news?.content?.summary?.substring(0, 150)}
                    </h4>
                  )}
                  {!!isTranslated && (
                    <h4
                      className={styles.h4Title}
                      // ref={cardMediaTextRef}
                    >
                      {translations?.res2[i]?.data}
                    </h4>
                  )}
                  <p className={styles.textDesc}>
                    {(
                      news?.content?.extracted?.publisher ||
                      news?.content?.opoint?.site_name ||
                      news?.content?.link ||
                      news?.content?.extracted?.copyright ||
                      news?.content?.extracted?.author
                    )?.slice(0, 100)}
                    {` `}
                    {normalisedTimeFormat(
                      news?.updated_at || news?.created_at,
                      true
                    )}
                  </p>
                </a>
              </div>
              {/* <SwichNewsIconWrapper
                style={{
                  marginLeft: 0,
                  marginRight: "16px",
                  // width: '20%',
                  display: "flex",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  window.open("/spotlight/" + news?.id);
                  // window.location.href = "/spotlight/" + news1?.id;
                  // e.stopPropagation()
                  // e.preventDefault()
                  // setnewsId(() => item?.id)
                }}
              >
                <SwitchNewsIcon src={SwitcherNews}></SwitchNewsIcon>
                <SwitchNewsIcon src={SwitcherNewsClicked}></SwitchNewsIcon>
              </SwichNewsIconWrapper> */}

              <div onClick={(e) => {
                  window.open("/spotlight/" + news?.id);
                  // window.location.href = "/spotlight/" + news1?.id;
                  // e.stopPropagation()
                  // e.preventDefault()
                  // setnewsId(() => item?.id)
                }}
                style={{
                  marginLeft: 0,
                  marginRight: "0.6rem",
                  // width: '20%',
                  display: "flex",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                }}
                >
          <SpotlightBtn isAuthed={true}
                    isNewsBookMarked={false}/>
            
          </div>
            </div>
          ))}
        {/* <a href="https://www.youtube.com/" target="_blank" rel="noreferrer" className="">
                    <p className={styles.textDesc}>Business Wire 11.12.2020 23:04</p>
                    <h4 className={styles.h4Title}>
                        Updated Outcome and Treatment Benefit Data from MINDACT Study
                        Reinforce Real-World Value
                    </h4>
                </a> */}
      </Carousel>
    </div>
  );
};

export default LatestNews;

const SwitchNewsIcon = styled.img`
  width: 32px;
  height: 32px;
`;

const SwichNewsIconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  background: #e8ebeb;
  border-radius: 100%;
  margin-left: 36px;
  margin-right: 36px;
  //   box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  width: 39px;
  height: 39px;
  & img:first-child {
    width: 39px;
    height: 39px;
  }
  & img:last-child {
    display: none;
    width: 0;
    height: 0;
  }
  &:hover img:last-child {
    display: block;
    width: 39px;
    height: 39px;
  }
  &:hover img:first-child {
    display: none;
  }
`;
